import React, { forwardRef } from 'react';
import cn from 'classnames';

import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import Callback from './callback/callback';
import Chat from './chat/chat';
import Socials from './socials/socials';

interface Container {
  maxSize: Env.MaxSize;
}

const Container = forwardRef<HTMLDivElement, Container>(({ maxSize }, ref) => {
  const { isWidgetActive, widget } = useWidgetContext();

  const style = {
    maxHeight: widget.type == 'vertical' ? maxSize?.maxHeight : undefined,
    maxWidth: widget.type == 'horizontal' ? maxSize?.maxWidth : undefined,
  };

  return (
    <div
      className={cn('whatcrm-widget-container', {
        'whatcrm-widget-container_active': isWidgetActive,
        [`whatcrm-widget-container_${widget.type}`]: widget.type,
      })}
      style={style}
    >
      <div className="whatcrm-widget-container__wrapper" ref={ref}>
        {widget.is_chat && <Chat />}
        <Socials />
        {widget.is_callback && <Callback />}
      </div>
    </div>
  );
});

Container.displayName = 'Container';
export default Container;
